"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputFileComponent = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button"));

var _config = require("../config/config");

var _withNamedError = _interopRequireDefault(require("../withNamedError"));

var InputFileComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(InputFileComponent, _Component);

  function InputFileComponent() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, InputFileComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(InputFileComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleChange", function (e) {
      if (e.target.files.length > 0) {
        _this.setState({
          filename: e.target.files[0].name
        });
      } else {
        _this.setState({
          filename: null
        });
      }

      _this.props.onChange && _this.props.onChange(e);
    });
    return _this;
  }

  (0, _createClass2.default)(InputFileComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          className = _this$props.className,
          error = _this$props.error,
          name = _this$props.name,
          chooseFileLabel = _this$props.chooseFileLabel,
          fileNotSelectedLabel = _this$props.fileNotSelectedLabel;
      return _react.default.createElement("label", {
        className: (0, _classnames.default)('form-field', className, {
          'form-field--error': error
        })
      }, _react.default.createElement(_Button.default, null, _react.default.createElement("input", {
        className: "btn-input",
        type: "file",
        name: name,
        onChange: this.handleChange
      }), chooseFileLabel || (0, _config.__)('Choose File')), _react.default.createElement("span", {
        className: (0, _classnames.default)('form-field-file-name', {
          'form-field-file-name--empty': !this.state.filename
        })
      }, this.state.filename || fileNotSelectedLabel || (0, _config.__)('File not selected')));
    }
  }]);
  return InputFileComponent;
}(_react.Component);

exports.InputFileComponent = InputFileComponent;
InputFileComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  onChange: _propTypes.default.func.isRequired,
  name: _propTypes.default.string,
  label: _propTypes.default.node,
  className: _propTypes.default.string,
  error: _propTypes.default.node,
  chooseFileLabel: _propTypes.default.node,
  fileNotSelectedLabel: _propTypes.default.node
} : {};
var InputFile = (0, _withNamedError.default)(InputFileComponent);
var _default = InputFile;
exports.default = _default;